import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import type { IInteractionsDefinition } from '@wix/viewer-service-interactions/definition'
import type { InteractionsPageConfig } from './types'
import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { PageFeatureConfigSymbol, StructureAPI } from '@wix/thunderbolt-symbols'
import { InteractionsDefinition as definition } from '@wix/viewer-service-interactions/definition'
import { InteractionsService as impl } from '@wix/viewer-service-interactions/implementations'
import { getCompIdToTemplateCompPath } from '@wix/thunderbolt-commons'
import { assignCompPathToInteractionsConfig } from './interactionsConfigUtils'
import { name } from './symbols'
import { EMPTY_INTERACTIONS_CONFIG } from './constants'

export const pageInteractionsService = withDependencies(
	[named(PageFeatureConfigSymbol, name), StructureAPI],
	({ interactionsConfig }: InteractionsPageConfig, structure): ServiceProvider<IInteractionsDefinition, any> => {
		const compIdToTemplateCompPath = getCompIdToTemplateCompPath(structure)
		const interactionsConfigWithTemplateCompPath = assignCompPathToInteractionsConfig(
			interactionsConfig,
			compIdToTemplateCompPath
		)
		return {
			definition,
			impl,
			config: interactionsConfigWithTemplateCompPath,
			// @ts-expect-error - the generated config is serializable and does not conatin functions/dom elements/class instances
			platformConfig: interactionsConfigWithTemplateCompPath,
		}
	}
)
export const siteInteractionsService = withDependencies([], (): ServiceProvider<IInteractionsDefinition, any> => {
	return {
		definition,
		impl,
		config: EMPTY_INTERACTIONS_CONFIG,
		// @ts-expect-error - empty config is serializable
		platformConfig: EMPTY_INTERACTIONS_CONFIG,
	}
})
